import React, { useEffect, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../assets/schemas/schemas';
import { RenovationSearchForm } from '../../common/Forms/Form';
import { AltButton, LogoButton } from '../../common/Buttons/Buttons';
import logo from '../../../images/logo.svg';
import { membershipService } from '../../../services/membershipService.js';
import { vehicleService } from '../../../services/vehicleService';
import { customerService } from '../../../services/customerService.js';
import { notify } from '../../../assets/helpers/toast';
import { Input } from '../../common/Forms/Input/Input.jsx';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';
import { ActionButton } from '../../../components/common/Buttons/Buttons.jsx';
import { MembershipImage } from '../Landing/LandingComponents/LandingComponents.jsx';
import {
  capitalize,
  phoneCodes,
  renewalEnum,
} from '../../../assets/helpers/options.js';
import {
  UpdateUserModal,
  UpdateVehicleModal,
} from '../../common/Modals/Modals.jsx';
import { useDropzone } from 'react-dropzone';
import moment from 'moment';
import {
  filterParams,
  removeBlankSpacesAndUppercase,
} from '../../../assets/helpers/funciones.js';
import { useHistory } from 'react-router-dom';
import './Login.scss';

export const Login = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemas.renovationSearchSchema(t)),
  });

  const {
    register: resister2,
    handleSubmit: handleSubmit2,
    watch: watch2,
    control: control2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm({
    resolver: yupResolver(schemas.updateRenovationSchema(t)),
  });

  const {
    register: resister3,
    handleSubmit: handleSubmit3,
    watch: watch3,
    control: control3,
    reset: reset3,
    formState: { errors: errors3 },
  } = useForm({
    resolver: yupResolver(schemas.updateVehicleSchema(t)),
  });

  const [isLoading, setIsloading] = useState(false);
  const [noFindMessage, setNoFindMessage] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showUpdateVehicleModal, setShowUpdateVehicleModal] = useState(false);
  const [vehicleBrandOptions, setVehicleBrandOptions] = useState([]);
  const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);

  const [foundMembership, setFoundMembership] = useState({
    vehicle: '',
    canRenovate: false,
  });
  const [identityDocument, setIdentityDocument] = useState([]);
  const [license, setLicense] = useState([]);
  const [circulationCard, setCirculationCard] = useState([]);

  const history = useHistory();

  const getFirstValue = (...values) => {
    return values.find(
      value => value !== undefined && value !== null && value !== ''
    );
  };

  const getRenewalPayload = response => {
    if (response?.data?.vehicle) return response.data;
    if (response?.data?.data?.vehicle) return response.data.data;
    return response?.data;
  };

  const onDrop1 = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();

      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setIdentityDocument(file);
      }
    });
  }, []);
  const onDrop2 = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();

      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setLicense(file);
      }
    });
  }, []);
  const onDrop3 = useCallback(acceptedFiles => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();

      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setCirculationCard(file);
      }
    });
  }, []);

  const { getRootProps: getRootProps1, getInputProps: getInputProps1 } =
    useDropzone({ onDrop: onDrop1 });
  const { getRootProps: getRootProps2, getInputProps: getInputProps2 } =
    useDropzone({ onDrop: onDrop2 });
  const { getRootProps: getRootProps3, getInputProps: getInputProps3 } =
    useDropzone({ onDrop: onDrop3 });

  // Function that handles the logout request

  const redirectToRenovationForm = () => {

    const dataLayer = {
      event: 'funnel_renovacion_step_vehicle_info',
      plan_category: `Planes de ${capitalize(foundMembership?.vehicle?.class?.class)}`,
      plan_name: (foundMembership?.vehicle?.membership?.code),
      vehicle_class: capitalize(foundMembership?.vehicle?.type),
      plate: foundMembership?.vehicle?.plate,
      make: capitalize(foundMembership?.vehicle?.brand),
      model: capitalize(foundMembership?.vehicle?.model),
      color: capitalize(foundMembership?.vehicle?.color),
      vehicle_year: foundMembership?.vehicle?.year,
    }
    // If logged In
    window.dataLayer.push(dataLayer);
    localStorage.setItem('membership', JSON.stringify(foundMembership));
    history.push(`/renew/${foundMembership?.vehicle?.membership?._id}`);
  };

  const loadValues = data => {
    const vehicle = data?.vehicle || {};
    const customer = vehicle?.customer || {};
    const membership = vehicle?.membership || {};

    const vehicleClass = getFirstValue(
      vehicle?.class?.class,
      vehicle?.className,
      vehicle?.class
    );
    const vehicleType = getFirstValue(
      vehicle?.type?.type,
      vehicle?.typeName,
      vehicle?.type
    );
    const vehicleBrand = getFirstValue(
      vehicle?.brand?.brand,
      vehicle?.brandName,
      vehicle?.brand
    );
    const vehicleModel = getFirstValue(
      vehicle?.model?.model,
      vehicle?.modelName,
      vehicle?.model
    );

    setValue('class', capitalize(vehicleClass));
    setValue('plate', vehicle?.plate);
    setValue('type', capitalize(vehicleType));
    setValue('year', vehicle?.year);
    setValue('brand', capitalize(vehicleBrand));
    setValue('model', capitalize(vehicleModel));
    setValue('color', capitalize(vehicle?.color));

    // Customer Data
    setValue(
      'firstName',
      `${capitalize(customer?.firstName)} ${capitalize(customer?.lastName)}`.trim()
    );
    setValue(
      'identification',
      `${customer?.identificationType || ''}-${customer?.identification || ''}`
    );
    setValue(
      'phoneNumber',
      `${customer?.phonePrefix || ''}-${customer?.phoneNumber || ''}`
    );
    setValue('email', (customer?.email || '').toLowerCase());

    if (membership?.endDate) {
      setValue('endDate', new Date(membership?.endDate));
    }
    if (membership?.beginDate) {
      setValue('beginDate', new Date(membership?.beginDate));
    }
    if (membership?.rcvBeginDate) {
      setValue('rcvBeginDate', new Date(membership?.rcvBeginDate));
    }
    if (membership?.rcvEndDate) {
      setValue('rcvEndDate', new Date(membership?.rcvEndDate));
    }
  };

  const onSubmit = handleSubmit(async data => {
    let params = {
      plate: data?.plate,
      identification: data?.identification,
    };

    setIsloading(true);
    membershipService
      .findRenewal(params)
      .then(response => {
        const renewalPayload = getRenewalPayload(response);
        const renewalMessage = getFirstValue(
          renewalPayload?.message,
          response?.message
        );
        const renewalVehicle = renewalPayload?.vehicle;

        let dataLayer = {}

        if (response.status === 200) {
          if (response?.data?.message === renewalEnum?.NO_MEMBERSHIP_FOUND) {
            setNoFindMessage(true)
            dataLayer = {
              event: 'funnel_renovacion_step_datos_afiliado',
              validation: 'no exitosa'
            }
          }
          if (renewalMessage === renewalEnum?.NOT_FOR_RENEWAL) {
            loadValues(renewalPayload);
            // Vehicle Data

            dataLayer = {
              event: 'funnel_renovacion_step_datos_afiliado',
              validation: 'no exitosa'
            }

            setFoundMembership((prevState) => {
              return {
                ...prevState,
                vehicle: renewalVehicle,
                canRenovate: false,
              };
            });
          }
          if (
            [renewalEnum?.SUCCEESS, renewalEnum?.EXPIRED]?.includes(
              renewalMessage
            )
          ) {
            sessionStorage.setItem('vehicle', JSON.stringify(renewalVehicle));


            dataLayer = {
              event: 'funnel_renovacion_step_datos_afiliado',
              validation: 'exitosa'
            }


            loadValues(response?.data)

            setFoundMembership(prevState => {
              return {
                ...prevState,
                vehicle: renewalVehicle,
                canRenovate: true,
              };
            });
          }
          window.dataLayer.push(dataLayer);
          setIsloading(false);
        } else {
          notify(`${response.message}`, 'error');
          setIsloading(false);
        }
      })
      .catch(error => {
        setIsloading(false);
      });
  });

  const appendFile = data => {
    const formData = new FormData();
    formData.append('plate', foundMembership?.vehicle?.plate);
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    if (identityDocument) {
      formData.append('identityDocument', identityDocument);
    }
    if (license) {
      formData.append('license', license);
    }
    if (circulationCard) {
      formData.append('circulationCard', circulationCard);
    }

    return formData;
  };

  const appendVehicleFile = data => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });

    if (identityDocument) {
      formData.append('identityDocument', identityDocument);
    }
    if (license) {
      formData.append('license', license);
    }
    if (circulationCard) {
      formData.append('circulationCard', circulationCard);
    }

    return formData;
  };

  const maskContact = contact => {
    if (contact.includes('@')) {
      // Mask email
      const [username, domain] = contact.split('@');
      const maskedUsername =
        username.slice(0, 2) +
        'X'.repeat(username.length - 2) +
        username.slice(-2);
      return maskedUsername + '@' + domain;
    } else {
      // Mask phone number
      const maskedNumber =
        contact.slice(0, 3) +
        'X'.repeat(contact.length - 9) +
        contact.slice(-4);
      return maskedNumber;
    }
  };

  const editCustomer = handleSubmit2(async data => {
    let dataToPost = {
      firstName: data?.firstName,
      lastName: data?.lastName,
      phonePrefix: data?.phonePrefix,
      phoneNumber: data?.phoneNumber,
      optionalPhonePrefix: data?.optionalPhonePrefix,
      optionalPhoneNumber: data?.optionalPhoneNumber,
      email: data?.email,
      birthday: data?.birthday,
      renewalCode: data?.renewalCode,
    };

    let fileToPost = appendFile(filterParams(dataToPost));
    setIsloading(true);

    if (!isLoading) {
      customerService
        .updateCustomerInRenewal(
          fileToPost,
          foundMembership?.vehicle?.customer?._id
        )
        .then(response => {
          if ([200, 201].includes(response.status)) {
            notify(`Datos editados`, 'success');
            setShowUpdateModal(!showUpdateModal);

            setValue(
              'firstName',
              response?.data?.customer?.firstName +
                ' ' +
                response?.data?.customer?.lastName
            );
            setValue(
              'phoneNumber',
              maskContact(
                response?.data?.customer?.phonePrefix +
                  '-' +
                  response?.data?.customer?.phoneNumber
              )
            );
            setValue(
              'email',
              maskContact(response?.data?.customer?.email.toLowerCase())
            );
            reset2();
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  });

  const validateImages = () => {
    if (!identityDocument) {
      notify('Por favor sube una imagen de tu cédula', 'error');
      return false;
    }

    if (!license) {
      notify('Por favor sube una imagen de tu licencia', 'error');
      return false;
    }
    if (!circulationCard) {
      notify('Por favor sube una imagen de tu tarjeta de circulación', 'error');
      return false;
    } else return true;
  };

  const editVehicle = handleSubmit3(async data => {
    let dataToPost = { ...data };

    dataToPost.customerId = foundMembership?.vehicle?.customer?._id;
    const validImages = validateImages();

    let fileToPost = appendVehicleFile(filterParams(dataToPost));

    if (!isLoading && validImages) {
      setIsloading(true);
      customerService
        .updateVehicleInRenewal(fileToPost, foundMembership?.vehicle?._id)
        .then(response => {
          if ([200, 201].includes(response.status)) {
            notify(`Datos editados`, 'success');
            setShowUpdateVehicleModal(!showUpdateVehicleModal);
            setValue('plate', response?.data?.vehicle?.plate);
            setValue('year', response?.data?.vehicle?.year);
            setValue('color', response?.data?.vehicle?.color);
            setValue('class', capitalize(response?.data?.vehicle?.className));
            setValue('type', capitalize(response?.data?.vehicle?.typeName));
            setValue('brand', capitalize(response?.data?.vehicle?.brandName));
            setValue('model', response?.data?.vehicle?.modelName);
            reset3();
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  });

  const validateRenewal = () => {
    if (watch('type') && watch('plate') && watch('class')) {
      return true;
    } else {
      return false;
    }
  };

  const hideNoFindMessage = (value, name) => {
    if (name === 'plate') {
      removeBlankSpacesAndUppercase(value, 'plate', setValue);
    }

    if (name === 'identification') {
      value = value.replace(/\s/g, '');
      setValue('identification', value);
    }

    setNoFindMessage(false);
  };

  const resetSearch = () => {
    setFoundMembership(prevState => {
      return {
        ...prevState,
        vehicle: '',
        canRenovate: false,
      };
    });
    setValue('plate', '');
    setValue('identification', '');
  };

  const sendRenewalCode = () => {
    membershipService
      .sendRenewalCode(foundMembership?.vehicle?.customer?._id)
      .then(response => {
        if (response.status === 200) {
          notify(
            `Se ha enviado un código de renovación a su correo ${watch('email')}`,
            'info'
          );
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(error => {});
  };

  const handleUpdateModal = open => {
    if (open) {
      // hacer request
      sendRenewalCode();
    }
    setShowUpdateModal(!showUpdateModal);
    setIdentityDocument('');
    setLicense('');
    setCirculationCard('');
  };

  const handleUpdateVehicleModal = open => {
    if (open) {
      // hacer request
      sendRenewalCode();
    }
    setShowUpdateVehicleModal(!showUpdateVehicleModal);
    setIdentityDocument('');
    setLicense('');
    setCirculationCard('');
  };

  const preloadForm = () => {};

  const getVehicleTypes = clase => {
    vehicleService
      .getVehicleTypes({ class: clase })
      .then(response => {
        if (response.status === 200) {
          setTypesOptions(response?.data?.types);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(error => {});
  };

  const getVehicleBrands = () => {
    vehicleService
      .getVehicleBrands()
      .then(response => {
        if (response.status === 200) {
          setVehicleBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(error => {});
  };

  const getVehicleModels = vehicleBrand => {
    vehicleService.getVehicleModels(vehicleBrand).then(response => {
      if (response.status === 200) {
        setVehicleModelOptions(response?.data?.models);
      } else {
        notify(`${response.message}`, 'error');
      }
    });
  };

  const getSalesVehicleClasses = async () => {
    vehicleService
      .getSalesVehicleClasses()
      .then(response => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(error => {});
  };

  useEffect(() => {
    getSalesVehicleClasses();
    getVehicleBrands();
    preloadForm();
  }, []);

  return (
    <>
      <UpdateUserModal
        show={showUpdateModal}
        register={resister2}
        errors={errors2}
        control={control2}
        watch={watch2}
        options={{ phoneCodes: phoneCodes }}
        handleModal={handleUpdateModal}
        action={editCustomer}
        fileUploaded={{
          identityDocument: identityDocument,
          license: license,
          circulationCard: circulationCard,
        }}
        setFileUploaded={{
          setIdentityDocument: setIdentityDocument,
          setLicense: setLicense,
          setCirculationCard: setCirculationCard,
        }}
        getRootProps={{
          getRootProps1: getRootProps1,
          getRootProps2: getRootProps2,
          getRootProps3: getRootProps3,
        }}
        getInputProps={{
          getInputProps1: getInputProps1,
          getInputProps2: getInputProps2,
          getInputProps3: getInputProps3,
        }}
      />

      <UpdateVehicleModal
        show={showUpdateVehicleModal}
        register={resister3}
        errors={errors3}
        control={control3}
        watch={watch3}
        options={{
          phoneCodes: phoneCodes,
          vehicleBrandOptions: vehicleBrandOptions,
          vehicleModelOptions: vehicleModelOptions,
          typesOptions: typesOptions,
          vehicleClassesOptions: vehicleClassesOptions,
        }}
        handleModal={handleUpdateVehicleModal}
        action={editVehicle}
        fileUploaded={{
          identityDocument: identityDocument,
          license: license,
          circulationCard: circulationCard,
        }}
        setFileUploaded={{
          setIdentityDocument: setIdentityDocument,
          setLicense: setLicense,
          setCirculationCard: setCirculationCard,
        }}
        getRootProps={{
          getRootProps1: getRootProps1,
          getRootProps2: getRootProps2,
          getRootProps3: getRootProps3,
        }}
        getInputProps={{
          getInputProps1: getInputProps1,
          getInputProps2: getInputProps2,
          getInputProps3: getInputProps3,
        }}
        onChange={{
          getVehicleTypes: getVehicleTypes,
          getVehicleModels: getVehicleModels,
        }}
      />

      <LoadSpinner label={''} show={isLoading} />
      <div className="container view-content">
        <div className="row">
          <div className="col-12 login-page-container">
            <div className="login-form">
              <div className="login-logo-container">
                <LogoButton link={'/'} src={logo} />
                <h5>Módulo de Renovación </h5>
              </div>
              {!foundMembership?.vehicle ? (
                <MembershipSearch
                  register={register}
                  errors={errors}
                  onSubmit={onSubmit}
                  watch={watch}
                  noFindMessage={noFindMessage}
                  hideNoFindMessage={hideNoFindMessage}
                />
              ) : (
                <MembershipFound
                  validateRenewal={validateRenewal}
                  register={register}
                  errors={errors}
                  control={control}
                  onSubmit={onSubmit}
                  watch={watch}
                  noFindMessage={noFindMessage}
                  foundMembership={foundMembership}
                  hideNoFindMessage={hideNoFindMessage}
                  resetSearch={resetSearch}
                  handleUpdateModal={handleUpdateModal}
                  handleUpdateVehicleModal={handleUpdateVehicleModal}
                  redirectToRenovationForm={redirectToRenovationForm}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const NoMembershipFould = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <h6>No hay coincidencias con estos datos</h6>
      <p>
        Por favor verifica los datos o comuniquese con nuestros asesores de
        ventas.
      </p>
    </div>
  );
};

export const MembershipSearch = props => {
  const {
    register,
    errors,
    onSubmit,
    noFindMessage,
    hideNoFindMessage,
    watch,
  } = props;
  return (
    <>
      <p style={{ margin: '0px', textAlign: 'center' }}>
        <b>Datos del Afiliado</b>
      </p>
      <RenovationSearchForm
        watch={watch}
        register={register}
        errors={errors}
        action={onSubmit}
        noFindMessage={noFindMessage}
        onChange={{ hideNoFindMessage: hideNoFindMessage }}
      />
      {noFindMessage && <NoMembershipFould />}
    </>
  );
};

export const MembershipFound = props => {
  const {
    register,
    errors,
    control,
    foundMembership,
    resetSearch,
    handleUpdateModal,
    handleUpdateVehicleModal,
    watch,
    redirectToRenovationForm,
    validateRenewal,
  } = props;
  return (
    <>
      <form className="form-container" style={{ marginBottom: '24px' }}>
        {foundMembership?.canRenovate && (
          <>
            <h5 style={{ margin: '0px', textAlign: 'center' }}>
              Datos del Cliente
            </h5>
            <br />
            <div className="row membership-found-container">
              <Input
                bootstrap={'col-6 col-md-6 col-lg-4'}
                label={'Nombre'}
                type={'text'}
                name={'firstName'}
                register={register}
                placeholder={''}
                errors={errors?.firstName?.message}
                disabled={true}
              />
              <Input
                bootstrap={'col-6 col-md-6 col-lg-2'}
                label={'Cédula'}
                type={'text'}
                name={'identification'}
                register={register}
                placeholder={''}
                errors={errors?.identification?.message}
                disabled={true}
              />
              <Input
                bootstrap={'col-6 col-md-6 col-lg-2'}
                label={'Teléfono'}
                type={'text'}
                name={'phoneNumber'}
                register={register}
                placeholder={''}
                errors={errors?.phoneNumber?.message}
                disabled={true}
              />
              <Input
                bootstrap={'col-6 col-md-6 col-lg-4'}
                label={'Correo'}
                type={'text'}
                name={'email'}
                register={register}
                placeholder={''}
                errors={errors?.email?.message}
                disabled={true}
              />
            </div>

            <p style={{ textAlign: 'center' }}>
              ¿Hay algún error en tus datos?{' '}
              <b onClick={() => handleUpdateModal(true)}>Modifícalos aquí</b>
            </p>
          </>
        )}

        <h5 style={{ margin: '0px', textAlign: 'center' }}>
          Datos del Vehiculo
        </h5>
        <br />
        <div className="row membership-found-container">
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Clase'}
            type={'text'}
            name={'class'}
            register={register}
            placeholder={''}
            errors={errors?.class?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Placa'}
            type={'text'}
            name={'plate'}
            register={register}
            placeholder={''}
            errors={errors?.plate?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Marca'}
            type={'text'}
            name={'brand'}
            register={register}
            placeholder={''}
            errors={errors?.brand?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Modelo'}
            type={'text'}
            name={'model'}
            register={register}
            placeholder={''}
            errors={errors?.model?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Año'}
            type={'number'}
            name={'year'}
            register={register}
            placeholder={''}
            errors={errors?.year?.message}
            disabled={true}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-2'}
            label={'Color'}
            type={'text'}
            name={'color'}
            register={register}
            placeholder={''}
            errors={errors?.color?.message}
            disabled={true}
          />
        </div>

        {!validateRenewal() && (
          <h6
            style={{
              textAlign: 'center',
              marginTop: '24px',
              marginBottom: '24px',
            }}
          >
            <span style={{ color: 'red' }}>
              OBLIGATORIO: Por favor completa la siguiente <br />{' '}
              información.{' '}
            </span>
            <span onClick={() => handleUpdateVehicleModal(true)}>
              CLICK AQUÍ
            </span>{' '}
          </h6>
        )}

        <h5 style={{ margin: '0px', textAlign: 'center' }}>
          Datos del último plan contratado
        </h5>

        <div className="membership-logo-container">
          <MembershipImage membership={foundMembership?.vehicle?.membership} />
        </div>
        <br />
        <div className="row">
          <div className="col-12 col-lg-3"></div>
          <Input
            bootstrap={'col-6 col-md-6 col-lg-3'}
            label={'Inicio del Plan'}
            type={'date'}
            name={'beginDate'}
            register={register}
            placeholder={''}
            control={control}
            errors={errors?.beginDate?.message}
            disabled={true}
            NA={!watch('beginDate')}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-3'}
            label={'Fin del Plan'}
            type={'date'}
            name={'endDate'}
            register={register}
            placeholder={''}
            control={control}
            errors={errors?.endDate?.message}
            disabled={true}
            NA={!watch('endDate')}
          />
          <div className="col-12 col-lg-3"></div>
          <div className="col-12 col-lg-3"></div>
          <Input
            bootstrap={'col-6 col-md-6 col-lg-3'}
            label={'Inicio del RCV'}
            type={'date'}
            name={'rcvBeginDate'}
            register={register}
            placeholder={''}
            control={control}
            errors={errors?.rcvBeginDate?.message}
            disabled={true}
            NA={!watch('rcvBeginDate')}
          />
          <Input
            bootstrap={'col-6 col-md-6 col-lg-3'}
            label={'Fin del RCV'}
            type={'date'}
            name={'rcvEndDate'}
            register={register}
            placeholder={''}
            control={control}
            errors={errors?.rcvEndDate?.message}
            disabled={true}
            NA={!watch('rcvEndDate')}
          />
          <div className="col-12 col-lg-3"></div>
        </div>
      </form>

      {!foundMembership?.canRenovate && (
        <p style={{ textAlign: 'center' }}>
          {' '}
          <b>No te encuentras dentro del periodo de renovación. </b>
          <br />
          Sigue disfrutando de los servicios que te ofrece tu plan! <br />
          <b>
            Puedes renovar a partir del{' '}
            {moment(foundMembership?.vehicle?.renewOn)
              ?.utcOffset(0)
              ?.format('DD/MM/YYYY')}
          </b>
        </p>
      )}

      <div className="buttons-center-container">
        <AltButton action={resetSearch} label={'Reiniciar Busqueda'} />

        {foundMembership?.canRenovate && validateRenewal() ? (
          <ActionButton
            action={redirectToRenovationForm}
            label={'Renovar plan'}
          />
        ) : (
          <ActionButton label={'Renovar plan'} disabled={true} />
        )}
      </div>
    </>
  );
};
